import { createAction } from '@reduxjs/toolkit';

import type {
  CreateAttributePayload,
  CreateVariantPayload,
  DeleteAttributePayload,
  DeleteVariantPayload,
  SetDefaultVariantPayload,
  UpdateAttributePayload,
  UpdateVariantPayload,
  VariantImportVariantsPayload,
} from '@polyai/stream/commands/handlers/variant';

const PREFIX = 'variant';

const createVariant = createAction<CreateVariantPayload>(
  `${PREFIX}/createVariant`,
);

const createAttribute = createAction<CreateAttributePayload>(
  `${PREFIX}/createAttribute`,
);

const updateVariant = createAction<UpdateVariantPayload>(
  `${PREFIX}/updateVariant`,
);

const updateAttribute = createAction<UpdateAttributePayload>(
  `${PREFIX}/updateAttribute`,
);

const deleteVariant = createAction<DeleteVariantPayload>(
  `${PREFIX}/deleteVariant`,
);

const deleteAttribute = createAction<DeleteAttributePayload>(
  `${PREFIX}/deleteAttribute`,
);

const setDefaultVariant = createAction<SetDefaultVariantPayload>(
  `${PREFIX}/setDefaultVariant`,
);

const variantImportVariants = createAction<VariantImportVariantsPayload>(
  `${PREFIX}/variantImportVariants`,
);

export {
  createAttribute,
  createVariant,
  deleteAttribute,
  deleteVariant,
  setDefaultVariant,
  updateAttribute,
  updateVariant,
  variantImportVariants,
};
